import React from 'react';
import { Form, Button, FormControl } from 'react-bootstrap';
import { reactLocalStorage } from 'reactjs-localstorage';

import AutomationAssigmnent from '../../../automation/AutomationAssigmnent';

import Const from '../../../../../util/Constants';
import Util from '../../../../../util/Util';

import FacebookV2API from '../../../../../api/FacebookV2API';
import FieldController from '../../../../../controller/FieldController';
import FbFieldAssigment from './FbFieldAssigment';
import withRouter from '../../../../../util/WithRouter';

class FacebookMapping extends React.Component {
  constructor(props) {
    super(props);
    const id = parseInt(props.match?.params?.id || 0);

    this.state = {
      id: id,
      inApiCall: id !== 0,
      inValid: {},
      name: '',
      module: Const.Lead,
      
      // Facebook specific state
      integrations: [],
      selectedIntegration: null,
      pages: [],
      selectedPage: null,
      forms: [],
      selectedForm: null,
      questions: [],
    };

    this.fields = [{}];
    this.assigments = [{}];
    this.api_data = { api_module: Const.Lead };
    
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.lead;
    this.modelFields = FieldController.getFilterFields(this.model.fields);

    this.zones = this.models.zone.options;
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    if(user.zone) {
      const zoneId = parseInt(user.zone.split(Const.Opt)[0]);
      this.dZone = this.zones.find(zone => zone.value === zoneId);
    } else {
      this.dZone = this.zones.find(zone => zone.value === 121);
    }
  }

  componentDidMount() {
    this.loadIntegrations();
  }

  formatAssign = (field, format, zone) => {
    if(!this.api_data) this.api_data = {};
    if(!this.api_data[field]) this.api_data[field] = { format, zone };
    this.api_data[field].format = format.value;
    this.api_data[field].zone = zone.value;
  }

  loadIntegrations = () => {
    this.setState({ inApiCall: true });
    // Fetch connected FB accounts
    FacebookV2API.listAccounts((res) => {
      const integrations = res.accounts || [];
      this.setState({ integrations, inApiCall: false }, () => {
        // Auto-select if only one account is connected
        if (integrations.length === 1) {
          this.onIntegrationChange(integrations[0]);
        }
        if (this.state.id !== 0) {
          this.loadExistingMapping();
        }
      });
    }, (err) => {
      Util.showError("Failed to load Facebook accounts");
      this.setState({ inApiCall: false });
    });
  };

  loadExistingMapping = () => {
    this.setState({ inApiCall: true });
    // Fetch the existing api_model row
    FacebookV2API.getMapping(this.state.id, (api) => {
      this.fields = JSON.parse(api.fields || '[]');
      if (this.fields.length === 0) this.fields = [{}];
      
      this.assigments = JSON.parse(api.assigments || '[]');
      if (this.assigments.length === 0) this.assigments = [{}];

      this.api_data = JSON.parse(api.api_data || '{}');
      
      this.setState({ name: api.name || '' }, () => {
        // Restore state hierarchy: Integration -> Page -> Form
        if (this.api_data.integration_id) {
          const intg = this.state.integrations.find(i => i.integration_id === this.api_data.integration_id);
          if (intg) this.onIntegrationChange(intg, () => {
            if (this.api_data.page_id) {
              const page = this.state.pages.find(p => p.id === this.api_data.page_id);
              if (page) this.onPageChange(page, () => {
                if (this.api_data.form_id) {
                  const form = this.state.forms.find(f => f.id === this.api_data.form_id);
                  if (form) this.onFormChange(form);
                }
              });
            }
          });
        }
        this.setState({ inApiCall: false });
      });
    }, (err) => {
      Util.showError("Failed to load mapping");
      this.setState({ inApiCall: false });
    });
  };

  onIntegrationChange = (integration, cb) => {
    this.setState({ 
      selectedIntegration: integration, 
      pages: [], selectedPage: null, 
      forms: [], selectedForm: null, 
      questions: [], 
      inApiCall: true 
    });
    FacebookV2API.fetchPages(integration.integration_id, (res) => {
      this.setState({ pages: res.pages || [], inApiCall: false }, () => { if (cb) cb(); });
    }, (err) => {
      Util.showError("Failed to load pages");
      this.setState({ inApiCall: false });
    });
  };

  onPageChange = (page, cb) => {
    this.setState({ selectedPage: page, forms: [], selectedForm: null, questions: [], inApiCall: true });
    FacebookV2API.fetchForms(this.state.selectedIntegration.integration_id, page.id, (res) => {
      this.setState({ forms: res.forms || [], inApiCall: false }, () => { if (cb) cb(); });
    }, (err) => {
      Util.showError("Failed to load forms");
      this.setState({ inApiCall: false });
    });
  };

  onFormChange = (form, cb) => {
    this.setState({ selectedForm: form, questions: [], inApiCall: true });
    FacebookV2API.getFormFields(
      this.state.selectedIntegration.integration_id, 
      this.state.selectedPage.id, 
      form.id, 
      (res) => {
        this.setState({ questions: res.questions || [], inApiCall: false }, () => { if (cb) cb(); });
      }, (err) => {
        Util.showError("Failed to load form fields");
        this.setState({ inApiCall: false });
      }
    );
  };

  nameChange = event => this.setState({ name: event.target.value });

  addField = () => { this.fields.push({}); this.setState({ inValid: {} }); }
  editField = (index, field) => {
    this.fields[index] = field;
    this.setState({});
  };
  deleteField = index => {
    this.fields = this.fields.filter((_, i) => i !== index);
    this.setState({ inValid: {} });
  }

  addAssign = () => { this.assigments.push({}); this.setState({ inValid: {} }); }
  editAssign = (index, assigment) => this.assigments[index] = assigment;
  deleteAssign = index => {
    this.assigments = this.assigments.filter((_, i) => i !== index);
    this.setState({ inValid: {} });
  }

  onSave = () => {
    let inValid = {};
    if (!this.state.selectedIntegration) inValid.integration = 'Select Account';
    if (!this.state.selectedPage) inValid.page = 'Select Page';
    if (!this.state.selectedForm) inValid.form = 'Select Form';
    if (this.state.name.trim() === '') inValid.name = 'Name required';

    // Normalize + validate mapping rows (simple & composed)
    let composeError = false;
    const normalizedFields = [];
    this.fields.forEach(f => {
      if (!f || !f.field) return;                       // empty row, skip
      if (f.parts) {
        const parts = f.parts.filter(p => p.t === 'f' ? !!p.k : (p.v !== undefined && p.v !== ''));
        const fieldTokens = parts.filter(p => p.t === 'f');
        if (fieldTokens.length === 0) { composeError = true; return; }
        if (fieldTokens.length === 1 && parts.length === 1) {
          normalizedFields.push({ key: fieldTokens[0].k, field: f.field });
        } else {
          normalizedFields.push({ key: f.key, field: f.field, parts });
        }
      } else if (f.key) {
        normalizedFields.push({ key: f.key, field: f.field });
      }
    });

    if (composeError) {
      Util.showNotification('Invalid mapping',
        'Composed values must contain at least one Facebook field. Use Static Assignments for text-only values.', 'danger');
      return;
    }
    if (normalizedFields.length === 0) inValid.fields = 'Map at least one field';

    if (Object.keys(inValid).length === 0) {
      this.setState({ inApiCall: true });
      const api = {
        id: this.state.id,
        name: this.state.name,
        method: Const.True,
        fields: JSON.stringify(normalizedFields),
        api_data: JSON.stringify({
          integration_id: this.state.selectedIntegration.integration_id,
          page_id: this.state.selectedPage.id,
          form_id: this.state.selectedForm.id,
          api_module: Const.Lead
        }),
        assigments: JSON.stringify(this.assigments),
        api_id: 0,
        type: 2,
        model_no: Const.Lead,
        party_type: Const.Facebook,
        status: Const.Active
      };

      FacebookV2API.saveMapping(api, () => {
        Util.showNotification('Success', 'Mapping saved successfully', 'success');
        this.props.navigate('/setting/third-party/facebook');
      }, (err) => {
        Util.showError(err.message || 'Failed to save mapping');
        this.setState({ inApiCall: false });
      });
    } else {
      Util.showNotification('Form incomplete', 'Please fill all required fields', 'danger');
      this.setState({ inValid });
    }
  };

  render() {
    const { inValid, integrations, selectedIntegration, pages, selectedPage, forms, selectedForm, questions } = this.state;
    
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12 pb-4"><h3>Facebook Lead Mapping</h3></div>
          </div>
          <Form className="row row-cols-3 lead-form">
            
            {/* 1. Select Integration */}
            <div className="col-md-12 pb-3">
              <Form.Group>
                <Form.Label>Connected Facebook Account</Form.Label>
                <Form.Control as="select" 
                  value={selectedIntegration?.integration_id || ''}
                  onChange={(e) => {
                    const intg = integrations.find(i => i.integration_id === parseInt(e.target.value));
                    if (intg) this.onIntegrationChange(intg);
                  }}
                  className={inValid.integration ? 'is-invalid' : ''}>
                  <option value="">Select Account</option>
                  {integrations.map(i => (
                    <option key={i.integration_id} value={i.integration_id}>{i.account_name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>

            {/* 2. Select Page */}
            {selectedIntegration && (
              <div className="col-md-6 pb-3">
                <Form.Group>
                  <Form.Label>Select Page</Form.Label>
                  <Form.Control as="select" 
                    value={selectedPage?.id || ''}
                    onChange={(e) => {
                      const page = pages.find(p => p.id === e.target.value);
                      if (page) this.onPageChange(page);
                    }}
                    className={inValid.page ? 'is-invalid' : ''}>
                    <option value="">Select Page</option>
                    {pages.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </Form.Control>
                </Form.Group>
              </div>
            )}

            {/* 3. Select Form */}
            {selectedPage && (
              <div className="col-md-6 pb-3">
                <Form.Group>
                  <Form.Label>Select Lead Form</Form.Label>
                  <Form.Control as="select" 
                    value={selectedForm?.id || ''}
                    onChange={(e) => {
                      const form = forms.find(f => f.id === e.target.value);
                      if (form) this.onFormChange(form);
                    }}
                    className={inValid.form ? 'is-invalid' : ''}>
                    <option value="">Select Form</option>
                    {forms.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
                  </Form.Control>
                </Form.Group>
              </div>
            )}

            {/* 4. Mapping Name */}
            {selectedForm && (
              <div className="col-md-12 pb-3">
                <Form.Group>
                  <Form.Label>Mapping Name</Form.Label>
                  <FormControl type='text' placeholder='e.g. Summer Campaign - OrgGen Page'
                    className={inValid.name ? 'is-invalid' : ''}
                    value={this.state.name} onChange={this.nameChange}/>
                </Form.Group>
              </div>
            )}

            {/* 5. Field Mapping */}
            {selectedForm && (
              <>
                <div className="formhead col-md-12"><h4>Field Mapping</h4></div>
                {/* Pass FB questions as source fields so the user can map them to CRM fields */}
                <FbFieldAssigment 
                  fields={this.modelFields}
                  fbFields={this.state.questions}
                  value={this.fields}
                  zones={this.zones}
                  dZone={this.dZone}
                  api_data={this.api_data}
                  onAdd={this.addField}
                  onEdit={this.editField}
                  onDelete={this.deleteField}
                  onFormat={this.formatAssign}
                />
              </>
            )}

            {/* 6. Static Assignments */}
            {selectedForm && (
              <>
                <div className="formhead col-md-12"><h4>Static Assignments</h4></div>
                <AutomationAssigmnent 
                  fields={this.modelFields} 
                  module={this.state.module} 
                  assigments={this.assigments} 
                  model={this.model} 
                  onAdd={this.addAssign} 
                  onEdit={this.editAssign} 
                  onDelete={this.deleteAssign} 
                />
              </>
            )}

            <div className="col-md-12 text-center btnsend mt-4">
              <Button variant="success" onClick={this.onSave} disabled={this.state.inApiCall}>
                {this.state.inApiCall ? 'Saving...' : 'Save Mapping'}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export default withRouter(FacebookMapping);